function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaymentMethodCardMobileOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.16 4.059h10.368c.573 0 1.037.464 1.037 1.037V14h2.074V5.096a3.11 3.11 0 00-3.11-3.11H5.16a3.11 3.11 0 00-3.11 3.11v19.93a3.11 3.11 0 003.11 3.11h2.832v-2.073H5.16a1.037 1.037 0 01-1.036-1.037V5.096c0-.573.464-1.037 1.036-1.037z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.935 6.393a.9.9 0 01.9-.9h3.019a.9.9 0 010 1.8H8.835a.9.9 0 01-.9-.9zM10 20.027h20v2H10v-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.027a2 2 0 00-2 2V28a2 2 0 002 2h16a2 2 0 002-2v-9.973a2 2 0 00-2-2H12zm16 2H12V28h16v-9.973z",
    fill: props.color
  }));
}

export default SvgIconPaymentMethodCardMobileOutline;